import {
  BookOpen,
  School,
  Users,
  UserCheck,
  MapPin,
  GraduationCap,
  Shield
} from 'lucide-react';

export const PERFIL_INFO: Record<string, { label: string; icon: any; desc: string }> = {
  professores: { label: 'Professores', icon: BookOpen, desc: 'Treinamentos para o corpo docente e diário' },
  diretores: { label: 'Diretores / Escola', icon: School, desc: 'Gestão escolar, turmas e matrículas' },
  secretarias: { label: 'Secretarias / Equipe', icon: Users, desc: 'Secretaria escolar, portaria e equipe' },
  coordenadores: { label: 'Coordenadores', icon: UserCheck, desc: 'Coordenação pedagógica e ocorrências' },
  prefeituras: { label: 'Prefeituras (Municipal)', icon: MapPin, desc: 'Inteligência e estatísticas do município' },
  estadual: { label: 'Gestão Estadual', icon: MapPin, desc: 'Acompanhamento regional e redes' },
  responsaveis: { label: 'Responsáveis / Família', icon: Users, desc: 'App de pais, comunicados e presença' },
  alunos: { label: 'Alunos', icon: GraduationCap, desc: 'App do aluno, grade e frequência' },
  administradores: { label: 'Master / Interno', icon: Shield, desc: 'Configuração geral e ferramentas master' },
};
